// Copyright (C) dātma, inc™ - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

// VERSION is on a line by itself for use with "cmd/bump-version", similar to:
// https://github.com/Shyp/bump_version - Do NOT edit manually!
export const VERSION = '2.412.0'
